<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
    <el-dialog
      :visible.sync="$store.store.state.dialogVisibleImg"
      class="dialog_banner"
    >
      <img
        width="100%"
        alt=""
        v-for="(imgItem, index) in $store.store.state.dialogImageUrl"
        :key="index"
        :src="imgItem"
      />
    </el-dialog>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import home from "@/view/home.vue";
import Footer from "@/components/footer.vue";
export default {
  name: "App",
  components: {
    Header,
    home,
    Footer,
  },
  created() {
    console.log(document.documentElement.clientHeight);
    var windowheight = document.documentElement.clientHeight - 275;
    this.$store.store.commit("setheight", windowheight);
    window.sessionStorage.setItem("menutype", 1);
  },
};
</script>

<style>
.dialog_banner .el-dialog__header {
  background-color: transparent;
  border-bottom: none;
}
.dialog_banner .el-dialog__body {
  margin-top: -10px;
}
.dialog_banner img {
  margin-bottom: 5px;
}
.header_top_right_in {
  margin-right: 27px;
  font-size: 14px;
  color: #808080;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.header_top_right_in:last-child {
  margin-right: 0;
}
.header_top_right_in i {
  margin-right: 5px;
}
.header_tooltip_text {
  text-align: center;
  font-size: 12px;
  color: #018277;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue